import React from 'react';
import PropTypes from 'prop-types';
import Select2 from "shared/react_components/Select2/index";
import FieldError from "./FieldError";

export default class AdvertiserCampaignSelect extends React.Component {
  render() {
    const validationClass = this.props.errorMessage ? "sb-field-group--invalid" : "";

    return (
      <div className={`sb-field-group ${validationClass}`} data-mount="advertiser_campaign_id">
        <label className="sb-field-label">{this.props.advertiserCampaignLabel}</label>
        <div data-mount="advertiser-campaign-area">
          <Select2 {...this.selectArgs()} />
        </div>
        <span id="advertiser_campaign_fixed"></span>
        <FieldError errorMessage={this.props.errorMessage} />
      </div>
    );
  }

  selectArgs() {
    return {
      friendlyNameField: this.props.friendlyNameField,
      uniqueNameField:   this.props.uniqueNameField,
      url:               this.props.destinationCampaign.advertiserCampaignUrl,
      node:              this.props.destinationCampaign,
      allowSearch:       this.props.allowSearch,
      changeListener:    this.props.changeListener,
      width:             "400px"
    };
  }
}

AdvertiserCampaignSelect.propTypes = {
  advertiserCampaignLabel:  PropTypes.string,
  friendlyNameField:        PropTypes.string,
  uniqueNameField:          PropTypes.string,
  allowSearch:              PropTypes.bool,
  destinationCampaign:      PropTypes.object,
  changeListener:           PropTypes.func,
  errorMessage:             PropTypes.string
};

AdvertiserCampaignSelect.defaultProps = {
  uniqueNameField:          "0",
  friendlyNameField:        "text",
  allowSearch:              true,
  advertiserCampaignLabel:  "Campaign",
  errorMessage:             ""
};
